import { render, staticRenderFns } from "./SWWCO.vue?vue&type=template&id=40fac790"
import script from "./SWWCO.vue?vue&type=script&lang=js"
export * from "./SWWCO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports